import API from '..';
const ENTITY = 'clients';

export const updateItem = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}`, data);
